import { fileSize } from '@bettermode/common/filesize'
import { I18nShape } from '@tribeplatform/react-components/i18n'
import { FileSizeLimitExceededError } from '@tribeplatform/react-sdk/types'
import { toast } from '@tribeplatform/react-ui-kit/Toast'

export const handleUploadFileError =
  ({ $t }: I18nShape) =>
  (error: unknown) => {
    if (error instanceof FileSizeLimitExceededError) {
      toast({
        title: $t({
          id: 'Generics.Error',
          defaultMessage: 'Error',
        }),
        description: $t(
          {
            id: 'Generics.FileSizeLimit',
            defaultMessage: 'The file size limit is {size_limit}.',
          },
          { size_limit: fileSize(error.limit) },
        ),
        status: 'error',
      })
      return
    }

    toast({
      title: $t({
        id: 'Generics.Error',
        defaultMessage: 'Error',
      }),
      description: $t({
        id: 'Generics.UploadError',
        defaultMessage: 'Failed to upload.',
      }),
      status: 'error',
    })
  }
